import * as React from "react";
import { connect } from "react-redux";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
import TypeContainer from "../../../Entity/Entities/Charge/Type/TypeContainer";
import Time from "../../../Time/Time";
// import { TypeInterface } from "../../../Entity/Entities/ContactForContract/Type/TypeInterface";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import { LeavePromptDialog } from "../../Partials/Dialog/LeavePromptDialog";
import { UnitInterface } from "../../../Entity/Entities/Unit/UnitInterface";
import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";
import { CompanyInterface } from "../../../Entity/Entities/Company/CompanyInterface";
import { ChargeTemplateInterface } from "../../../Entity/Entities/Charge/ChargeTemplateInterface";
import { DatePickerComponent } from "../../Partials/DatePicker/DatePickerComponent";
import UnitLookup from "../../Partials/Lookup/UnitLookup";
import PersonLookup from "../../Partials/Lookup/PersonLookup";
import { Tenant } from "../../../Entity/Entities/Person/Role/Roles/Tenant";
import { None } from "../../../Entity/Entities/Person/Role/Roles/None";
import { Occupant as OccupantRole } from "../../../Entity/Entities/Person/Role/Roles/Occupant";
import { Occupant as OccupantType } from "../../../Entity/Entities/ContactForContract/Type/Types/Occupant";
import { ChargeTemplateCreate } from "../../Partials/Dialog/ChargeTemplateCreate";
import { ChargeTemplateUpdate } from "../../Partials/Dialog/ChargeTemplateUpdate";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";
import ContractCreateWillMount from "../../../Middleware/Middlewares/ContractCreateWillMount";
import CurrencyContainer from "../../../Currency/CurrencyContainer";
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Card from '@material-ui/core/Card';
import IconButton from '@material-ui/core/IconButton';
import TextField from "../../Partials/Material/TextField";
import Button from '@material-ui/core/Button';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import PreventPageLeave from "../../../Middleware/Middlewares/PreventPageLeave";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import Formatter from "../../../Localization/Formatter";
import { AgencyFeeInterface } from "../../../Entity/Entities/AgencyFee/AgencyFeeInterface";
import { DeleteEntityPrompt } from "../../Partials/Dialog/DeleteEntityPrompt";
import AgencyFeeFactory from "../../../Entity/Factories/AgencyFeeFactory";
import PeriodContainer from "../../../Entity/Entities/Charge/Period/PeriodContainer";
import Translator from "../../../Translation/Translator";
import { Attachment } from "../../Partials/Attachment/Attachment";
import * as uuidV4 from "uuid/v4";
import Searchbar from "../../Partials/Searchbar/Searchbar";
import { Company } from "../../../Entity/Entities/Company/Company";
import { Person } from "../../../Entity/Entities/Person/Person";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { CoachNewTenantDialog } from "../../Partials/Dialog/CoachNewTenantDialog";
import ChargeTemplateCard from "../../Partials/ChargeTemplate/ChargeTemplateCard";

class ContractCreate extends Component {
  private disablePersonId: number;
  private disableUnitId: number;
  private shortContractWarningPeriod: number = 1000 * 60 * 60 * 24 * 5;

  public state = {
    ignoredPeople: [],
    id: 0,
    status: this.props.app.contractStatuses['CONCEPT'],
    firstDate: Time.firstDateNextMonth(),
    lastDate: Time.nextYearPrevMonthLastDay(Time.firstDateNextMonth()),
    finalRentalPeriodDate: null,
    endDate: null,
    expirationDate: Time.substractMonth(Time.nextYearPrevMonthLastDay(Time.firstDateNextMonth()), this.props.app.settings.agency.notificationPeriod),
    openLeavePrompt: false,
    datepickerError: "",
    datepickerHint: "",
    amazonFolderName: uuidV4(),
    canSelectTenant: false,
    isDialogOpen: false,
    isUpdating: false,
    openContractSigningDialog: false,
    note: "",
    hasModifiedData: false,
    errorForPerson: "",
    errorForUnit: "",
    autoSelectTenantId: null,
    isSaving: false,
    tooltipOpen: false,
    isAgencyFeeDialogOpen: false,
    agencyFee: null,
    anchorElAgencyFees: null,
    isAgencyRemoveDialog: false,
    beta: false,
    defaultAgencyFees: [],
    attachments: [],
    nextPath: "",
    selectedTenant: null,
    selectedUnit: null,
    additionalFields: [],
    lastSelectedIndex: null,
    createdContract: null,
    selectedAgencyFee: null,
    autoSendInvoiceToTenant: false,
    isCommercial: false,
    openCoachCreateNewTenant: false,
    addressForRentEmail: "",

    // charge templates
    chargeTemplates: [],
    isChargeTemplatePopupOpen: false,
    newChargeTemplatePopupOpen: null,
    anchorElChargeTemplate: null,
    selectedChargeTemplate: null,
    selectedChargeIndex: null,
  };

  protected shouldClearBeforeUnmounting: boolean = true;
  protected clearWith: string = Constants.GLOBAL_CONTRACT_CREATE_CLEAR;
  protected middlewares: MiddlewareInterface[] = [
    ContractCreateWillMount,
    PreventPageLeave
  ];

  constructor(public props) {
    super(props);

    this.disablePersonId = parseInt(this.props.params.personId, 10);
    this.disableUnitId = parseInt(this.props.params.unitId, 10);

    if (this.disablePersonId !== 0) {
      const person: PersonInterface = this.props.app.persons.find(person => person.id === this.disablePersonId);

      if (!!person) {
        this.state.selectedTenant = person;
      }
    }

    if (this.disableUnitId !== 0) {
      const unit: UnitInterface = this.props.units.byId[this.disableUnitId];

      if (!!unit) {
        this.state.selectedUnit = unit;
      }
    }
  }

  public componentDidMount() {
    document.addEventListener('click', this.clickOutside, false);
    // We have to have a short delay otherwise focus does not work in Safari and Chrome.
    setTimeout(() => {
      // Otherwise, we have to focus the TenantLookup or UnitLookup component because of user experience...
      if (!this.state.selectedTenant) {
        (this.refs.TenantLookup as any) && (this.refs.TenantLookup as any).refs.instance.ref.focus();
      }

      if (this.disableUnitId === 0) {
        (this.refs.UnitLookup as any) && (this.refs.UnitLookup as any).refs.instance.ref.focus();
      }
    }, 10);
  }

  public componentWillUnmount() {
    document.removeEventListener('click', this.clickOutside, false);

    if (this.state.nextPath) {
      this.redirect(this.state.nextPath);
    }
  }

  public clickOutside = (e) => {
    if (e.target != document.getElementById('tooltip-block')) {
      if (e.target != document.getElementById('hidden-hint')) {
        this.setState({
          tooltipOpen: false
        });
      } else {
        this.setState({
          tooltipOpen: true
        });
      }
    }
  }

  public addAdditionalFields = (): void => {
    const additionalFields = [...this.state.additionalFields];

    additionalFields.push({
      selectedPerson: null,
      description: this.trans("label-occupant"),
      contactForContractTypeId: OccupantType.contactForContractTypeId
    });

    this.setState({ additionalFields: [...additionalFields] });

    this.forceUpdate();
  }

  public renderAdditionalFields = (): any => {
    return this.state.additionalFields.map((data: any, index: number) => {
      if (!data) {
        return;
      }

      return (
        <div
          key={index}
          style={{ margin: "-14px 0", position: "relative" }}
        >
          <PersonLookup
            {...this.props}
            filterOutEntities={this.state.additionalFields}
            isInlineBlock={true}
            width="100%"
            containerWidth="60%"
            onFocus={() => this.setState({ lastSelectedIndex: index })}
            autoSelectId={data && data.selectedPerson ? data && data.selectedPerson.id : null}
            floatingLabelText={this.trans("dropdown-selectperson-label")}
            onSelect={this.selectAdditionalPerson}
            onClear={person => {
              const additionalFields = [...this.state.additionalFields];
              additionalFields[index].selectedPerson = null;

              this.setState({
                additionalFields: [...additionalFields],
                ignoredPeople: this.state.ignoredPeople.filter(p => p.id !== person.id)
              }, () => {
                this.setModifiedData();
              });
            }}
            forceUpdatePage={true}
            saveDetailsBeforeRedirect={this.saveDetailsBeforeRedirect.bind(this)}
            error={this.getErrorFor(`contactForContracts[${index + 1}].contactId`)}
          />

          <TextField
            autoComplete="off"
            className="form-element"
            style={{ width: "30%", boxSizing: "border-box", marginLeft: "45px" }}
            type="text"
            label={this.trans("label-description")}
            value={this.state.additionalFields[index].description}
            onChange={e => {
              const additionalFields = [...this.state.additionalFields];
              additionalFields[index].description = (e.currentTarget as any).value;
              this.setState({ additionalFields: [...additionalFields] });
              this.setModifiedData();
            }}
            variant="standard"
            error={false}
          />

          <div
            className="icon icon-ic-close clear-button"
            style={{
              display: "inline-block",
              position: "absolute",
              top: "25px",
              right: "0px",
              cursor: "pointer"
            }}
            onClick={this.removeAdditionalField.bind(this, index)}
          ></div>
        </div>
      );
    });
  }

  public removeAdditionalField = (index: number): void => {
    const additionalFields = [...this.state.additionalFields];
    additionalFields.splice(index, 1);

    this.setState({
      additionalFields: [...additionalFields],
      hasModifiedData: true
    });

    this.forceUpdate();
  }

  public selectDate = (momentDate: any, identifier: string): any => {
    const date = !!momentDate && typeof momentDate.toDate === "function" ? momentDate.toDate() : momentDate;
    const prevFirstDate = !!this.state.firstDate ? new Date(this.state.firstDate) : null;
    const prevLastDate = !!this.state.lastDate ? new Date(this.state.lastDate) : null;
    const prevFinalDate = !!this.state.finalRentalPeriodDate ? new Date(this.state.finalRentalPeriodDate) : null;
    const prevExpirationDate = !!this.state.expirationDate ? new Date(this.state.expirationDate) : null;

    // Update the state
    this.setState({
      [identifier]: date,
      hasModifiedData: true,
      datepickerHint: "",
      datepickerError: ""
    }, () => {
      // Show the hint if contract period is pretty short, like 5-6 days
      if (!!this.state.firstDate && !!this.state.lastDate &&
        (this.state.lastDate.getTime() - this.state.firstDate.getTime()) <= this.shortContractWarningPeriod) {
        this.setState({
          datepickerHint: this.trans("last-date-of-period-pretty-close")
        });
      }

      // when we change first date we also should syncronize value of last date if it wasn't changed manually
      if (identifier === "firstDate") {
        // we should also update the dates in charge templates
        // Put the current charge templates to the state of the component
        this.setState({
          chargeTemplates: this.state.chargeTemplates.map((chargeTemplate: ChargeTemplateInterface) => {
            let chargeTemplateFirstDate = chargeTemplate?.firstDate;
            let chargeTemplateDueDateFirstPayment = chargeTemplate?.dueDateFirstPayment;

            if (!!this.state.firstDate && !!chargeTemplate?.firstDate &&
              this.formatter.formatDate(prevFirstDate) === this.formatter.formatDate(chargeTemplate?.firstDate)) {
              chargeTemplateFirstDate = this.state.firstDate;
            }

            if (!this.state.firstDate && !!chargeTemplate?.firstDate &&
              this.formatter.formatDate(prevFirstDate) === this.formatter.formatDate(chargeTemplate?.firstDate)) {
              chargeTemplateFirstDate = this.state.firstDate;
            }

            if (!!this.state.firstDate && !prevFirstDate && !chargeTemplate?.firstDate) {
              chargeTemplateFirstDate = this.state.firstDate;
            }

            if (!!this.state.firstDate && !!chargeTemplate?.dueDateFirstPayment &&
              this.formatter.formatDate(prevFirstDate) === this.formatter.formatDate(chargeTemplate?.dueDateFirstPayment)) {
              chargeTemplateDueDateFirstPayment = this.state.firstDate;
            }

            if (!this.state.firstDate && !!chargeTemplate?.dueDateFirstPayment &&
              this.formatter.formatDate(prevFirstDate) === this.formatter.formatDate(chargeTemplate?.dueDateFirstPayment)) {
              chargeTemplateDueDateFirstPayment = this.state.firstDate;
            }

            if (!!this.state.firstDate && !prevFirstDate && !chargeTemplate?.dueDateFirstPayment) {
              chargeTemplateDueDateFirstPayment = this.state.firstDate;
            }

            return {
              ...chargeTemplate,
              firstDate: chargeTemplateFirstDate,
              dueDateFirstPayment: chargeTemplateDueDateFirstPayment
            }
          })
        });

        // we should update last date if it wasn't changed manually
        if (!!this.state.firstDate && !!this.state.lastDate &&
          this.formatter.formatDate(Time.nextYearPrevMonthLastDay(prevFirstDate)) === this.formatter.formatDate(this.state.lastDate)) {
          return this.selectDate(Time.nextYearPrevMonthLastDay(this.state.firstDate), "lastDate");
        }

        if (!this.state.firstDate && !!this.state.lastDate &&
          this.formatter.formatDate(Time.nextYearPrevMonthLastDay(prevFirstDate)) === this.formatter.formatDate(this.state.lastDate)) {
          return this.selectDate(this.state.firstDate, "lastDate");
        }

        if (!!this.state.firstDate && !prevFirstDate && !this.state.lastDate) {
          return this.selectDate(Time.nextYearPrevMonthLastDay(this.state.firstDate), "lastDate");
        }
      }

      // If the identifier is lastDate, we also have to update finalRentalPeriodDate and expirationDate
      // if they were not updated manually
      if (identifier === "lastDate") {
        if (!!this.state.lastDate && !!this.state.finalRentalPeriodDate &&
          this.formatter.formatDate(prevLastDate) === this.formatter.formatDate(this.state.finalRentalPeriodDate)) {
          this.selectDate(this.state.lastDate, "finalDate");
        }

        if (!this.state.lastDate && !!this.state.finalRentalPeriodDate &&
          this.formatter.formatDate(prevLastDate) === this.formatter.formatDate(this.state.finalRentalPeriodDate)) {
          this.selectDate(date, "finalDate");
        }

        if (!!this.state.lastDate && !prevLastDate && !prevFinalDate) {
          this.selectDate(date, "finalDate");
        }

        if (!!this.state.lastDate && !!this.state.expirationDate &&
          this.formatter.formatDate(Time.substractMonth(prevLastDate, this.props.app.settings.agency.notificationPeriod)) === this.formatter.formatDate(this.state.expirationDate)) {
          return this.selectDate(Time.substractMonth(this.state.lastDate, this.props.app.settings.agency.notificationPeriod), "expirationDate");
        }

        if (!this.state.lastDate && !!this.state.expirationDate &&
          this.formatter.formatDate(Time.substractMonth(prevLastDate, this.props.app.settings.agency.notificationPeriod)) === this.formatter.formatDate(this.state.expirationDate)) {
          return this.selectDate(this.state.lastDate, "expirationDate");
        }

        if (!!this.state.lastDate && !prevLastDate && !prevExpirationDate) {
          return this.selectDate(Time.substractMonth(this.state.lastDate, this.props.app.settings.agency.notificationPeriod), "expirationDate");
        }
      }
    });
  }

  public openChargeTemplateCreatePopup = () => {
    this.setState({
      newChargeTemplatePopupOpen: true
    }, () => {
      this.setState({
        isChargeTemplatePopupOpen: true
      })
    });
  }

  public closeChargeTemplatePopup = () => {
    this.setState({
      isChargeTemplatePopupOpen: false,
      isUpdating: false
    });
  }

  public save = () => {
    const payload: any = {
      сreatedOnFrontend: true,
      unit: this.state.selectedUnit,
      amazonFolderName: this.state.amazonFolderName,
      status: this.state.status,
      firstDate: this.state.firstDate,
      lastDate: this.state.lastDate,
      finalRentalPeriodDate: this.state.finalRentalPeriodDate,
      endDate: this.state.endDate,
      expirationDate: this.state.expirationDate,
      note: this.state.note,
      chargeTemplates: this.state.chargeTemplates,
      additionalFields: this.state.additionalFields,
      agencyFee: this.state.defaultAgencyFees[0],
      autoSendInvoiceToTenant: this.state.autoSendInvoiceToTenant,
      addressForRentEmail: this.state.addressForRentEmail,
      isCommercial: this.state.isCommercial,
    };

    if (this.state.selectedTenant instanceof Person) {
      payload.selectedPerson = this.state.selectedTenant;
    }

    if (this.state.selectedTenant instanceof Company) {
      payload.selectedCompany = this.state.selectedTenant;
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_CONTRACT_CREATE_START,
        payload: {
          ...payload
        },
        onSuccess: createdContract => {
          this.props.dispatch({
            type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
          });

          // we need this because after creating a new contract we always want to go to info tab first
          this.props.dispatch({
            type: Constants.PAGE_CONTRACT_UPDATE_SWITCH_TAB,
            payload: {
              index: 0
            }
          });

          return this.setState({
            isSaving: false,
            createdContract: createdContract
          }, () => {
            this.props.dispatch({
              type: Constants.SNACKBAR_ADD_MESSAGE,
              payload: {
                message: this.trans("you-created-concept-contract"),
                type: "info"
              }
            });

            return this.setState({
              nextPath: `/app/contract/update/${this.state.createdContract?.id}/${this.disablePersonId}/${this.disableUnitId}`
            }, this.redirectBack)
          });
        },
        onError: (err) => {
          console.log(err)
          const showAgencyFeeErrorDialog = err.fields?.some(field => field === "agencyFee.percentageFee")
          const showChargeTemplateErrorDialog = err.fields?.some(field => field.indexOf("chargeTemplates") === 0)
          let chargeTemplatesErrorRows = [];

          let chargeTemplatesErrorIndexRows = err.fields.filter(field => field.indexOf("chargeTemplates") === 0)
            .map(field => parseInt(field.match(/\d+/)));

          let chargeTemplatesError = err.fields.filter(field => field.indexOf("chargeTemplates") === 0)
          let chargeTemplatesErrorField;
          if (chargeTemplatesError[0]) {
            chargeTemplatesErrorField = chargeTemplatesError[0].split(".")
          }

          chargeTemplatesErrorRows.push(chargeTemplatesErrorIndexRows[0]); // just set first error from array
          const chargeTemplates = this.state.chargeTemplates.map((chargeTemplate, index) => {
            return {
              ...chargeTemplate,
              error: chargeTemplatesErrorRows?.some(field => field === index)
            }
          })

          this.setState({
            chargeTemplates: chargeTemplates,
            isSaving: false,
            hasModifiedData: true
          })

          if (showAgencyFeeErrorDialog) {
            this.props.dispatch({
              type: Constants.SNACKBAR_ADD_MESSAGE,
              payload: {
                message: this.trans("error-notvaliddatata-agencyfee"),
                type: "error"
              }
            });
          }

          if (showChargeTemplateErrorDialog) {
            this.props.dispatch({
              type: Constants.SNACKBAR_ADD_MESSAGE,
              payload: {
                message: this.trans("error-notvaliddatata-chargetemplate", { field: this.trans(`label-${chargeTemplatesErrorField[1]}`) }),
                type: "error"
              }
            });
          }
        }
      });
    });
  }

  protected openChargeTemplateMenu = (event: any, chargeTemplate: ChargeTemplateInterface, index): void => {
    this.setState({
      selectedChargeTemplate: chargeTemplate,
      anchorElChargeTemplate: event.currentTarget,
      selectedChargeIndex: index
    });
  }

  protected closeChargeTemplateMenu = (): void => {
    this.setState({
      anchorElChargeTemplate: null
    });
  }

  public comparer = (a, b) => {
    if (a > b) {
      return 1;
    }
    if (a < b) {
      return -1;
    }

    return 0;
  }

  public chargeTemplateComparer = (a, b) => {
    return this.comparer(a?.repeatPeriod, b?.repeatPeriod) ||
      this.comparer(TypeContainer.pickLabelFromId(a?.type), TypeContainer.pickLabelFromId(b?.type));
  }

  public getChargeTemplates = () => {
    return [...this.state.chargeTemplates]
      .filter((chargeTemplate: ChargeTemplateInterface) => !!chargeTemplate && !chargeTemplate.contractId)
      .map((chargeTemplate, index) => {
        return (
          <TableRow
            hover
            key={`chargeTemplate-${index}`}
            className={`clickable-entity`}
            onClick={() => {
              this.openChargeTemplateUpdatePopup(chargeTemplate, index);
            }}
          >
            <TableCell>
              {chargeTemplate?.error &&
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", paddingTop: "6px" }}>
                  <div
                    className="icon icon-ic-info red"
                  >
                  </div>
                </div>
              }
            </TableCell>
            <TableCell style={{ width: "15%" }}>
              {this.formatter.formatNumber(chargeTemplate?.amount * 100, CurrencyContainer.pickFromId(chargeTemplate?.currency))}
            </TableCell>
            <TableCell style={{ width: "15%" }}>{Formatter.checkTranslationType(this.trans(PeriodContainer.pickLabelFromId(chargeTemplate.repeatPeriod)), PeriodContainer.pickLabelFromId(chargeTemplate.repeatPeriod))}</TableCell>
            <TableCell style={{ width: "20%" }}>{Formatter.checkTranslationType(this.trans(TypeContainer.pickLabelFromId(chargeTemplate?.type), {}, "", false), TypeContainer.pickLabelFromId(chargeTemplate?.type), chargeTemplate?.type?.system)}</TableCell>
            <TableCell style={{ width: "10%" }}>
              {
                chargeTemplate?.isPaidDirectlyToOwner && (
                  <div style={{ padding: "2px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div className="list-label creation-type-label">
                      {this.trans("label-direct")}
                    </div>
                  </div>

                )
              }
            </TableCell>
            <TableCell style={{ width: "20%" }}>{chargeTemplate.description}</TableCell>
            <TableCell style={{ width: "15%" }}>{this.formatter.formatDate(chargeTemplate.dueDateFirstPayment) || this.formatter.formatDate(chargeTemplate.firstDate)}</TableCell>
            <TableCell
              onClick={e => {
                e.stopPropagation();
              }}
            >
              <div>
                <IconButton
                  onClick={e => {
                    this.openChargeTemplateMenu(e, chargeTemplate, index)
                  }}
                >
                  <div className="icon icon-ic-more-vert"></div>
                </IconButton>
                <Menu
                  id="simple-menu"
                  anchorEl={this.state.anchorElChargeTemplate}
                  open={Boolean(this.state.anchorElChargeTemplate) && this.state.selectedChargeIndex === index}
                  onClose={this.closeChargeTemplateMenu}
                  disableAutoFocusItem={true}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                  }}
                  getContentAnchorEl={null}
                >
                  <MenuItem
                    onClick={() => this.openChargeTemplateUpdatePopup(this.state.selectedChargeTemplate, this.state.selectedChargeIndex)}
                  >
                    <ListItemIcon><div className="icon icon-ic-edit icon-color"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-open")}</ListItemText>
                  </MenuItem>
                  <MenuItem
                    className="delete-action"
                    onClick={() => this.deleteChargeTemplate()}
                  >
                    <ListItemIcon><div className="icon icon-ic-remove icon-color remove-icon"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-delete")}</ListItemText>
                  </MenuItem>
                </Menu>
              </div>
            </TableCell>
          </TableRow>
        );
      });
  }

  public selectAdditionalPerson = (person: PersonInterface, isManuallySelected: boolean): void => {
    const additionalFields = [...this.state.additionalFields];

    if (isManuallySelected === true) {
      additionalFields[this.state.lastSelectedIndex].selectedPerson = person;
    }

    this.setState({
      hasModifiedData: isManuallySelected,
      additionalFields: [...additionalFields],
      ignoredPeople: [person, ...this.state.ignoredPeople]
    });
  }

  public addChargeTemplate = (chargeTemplate): any => {
    let createdChargeTemplate = { ...chargeTemplate };

    const chargeTemplates = [...this.state.chargeTemplates, createdChargeTemplate];
    chargeTemplates.sort(this.chargeTemplateComparer)

    this.setState({
      hasModifiedData: true,
      isChargeTemplatePopupOpen: false,
      chargeTemplates: chargeTemplates.map(chargeTemplate => {
        return {
          ...chargeTemplate,
          isPaidDirectlyToOwner: createdChargeTemplate?.isCollective && chargeTemplate?.isCollective ? createdChargeTemplate?.isPaidDirectlyToOwner : chargeTemplate?.isPaidDirectlyToOwner
        }
      }),
    }, () => {
      this.setState({
        isUpdating: false
      })
    })
  }

  public openChargeTemplateUpdatePopup = (chargeTemplate: ChargeTemplateInterface, index): any => {
    this.setState({
      selectedChargeIndex: index,
      selectedChargeTemplate: chargeTemplate,
      isUpdating: true,
      anchorElChargeTemplate: null,
      newChargeTemplatePopupOpen: false
    }, () => {
      this.setState({
        isChargeTemplatePopupOpen: true,
        isUpdating: true
      })
    });
  }

  public updateChargeTemplate = (updatedChargeTemplate: ChargeTemplateInterface): any => {
    let updatedChargeTemplates = this.state.chargeTemplates;

    updatedChargeTemplates.splice(this.state.selectedChargeIndex, 1, updatedChargeTemplate);
    updatedChargeTemplates.sort(this.chargeTemplateComparer)


    this.setState({
      chargeTemplates: updatedChargeTemplates.map(chargeTemplate => {
        return {
          ...chargeTemplate,
          isPaidDirectlyToOwner: updatedChargeTemplate?.isCollective && chargeTemplate?.isCollective ? updatedChargeTemplate?.isPaidDirectlyToOwner : chargeTemplate?.isPaidDirectlyToOwner
        }
      }),
      hasModifiedData: true,
      isChargeTemplatePopupOpen: false,
      isUpdating: false,
      selectedChargeIndex: null
    })
  }

  public deleteChargeTemplate = (): any => {
    this.closeChargeTemplateMenu();

    const updatedChargeTemplates = this.state.chargeTemplates;
    updatedChargeTemplates.splice(this.state.selectedChargeIndex, 1)
    updatedChargeTemplates.sort(this.chargeTemplateComparer)


    this.setState({
      chargeTemplates: updatedChargeTemplates,
      hasModifiedData: true,
      isChargeTemplatePopupOpen: false,
      selectedChargeIndex: null
    })
  }

  public getChargeTemplatePopupContent = (): any => {
    if (this.state.isUpdating) {
      return (
        <ChargeTemplateUpdate
          {...this.props}
          entity={"contract"}
          chargeTemplate={this.state.selectedChargeTemplate}
          onSave={this.updateChargeTemplate}
          onCancel={this.closeChargeTemplatePopup}
          chargeTemplateCreatedOnFrontend={true}
        />
      );
    }

    return (
      <ChargeTemplateCreate
        {...this.props}
        entity={"contract"}
        selectedType={TypeContainer.pickIdFromLabel("Basic_rent")}
        firstDate={this.state.firstDate ? new Date(this.state.firstDate) : null}
        contact={this.state.selectedTenant instanceof Person ? this.state.selectedTenant : null}
        company={this.state.selectedTenant instanceof Company ? this.state.selectedTenant : null}
        onSave={this.addChargeTemplate}
        onCancel={this.closeChargeTemplatePopup}
        chargeTemplateCreatedOnFrontend={true}
        existingChargeTemplates={this.state.chargeTemplates}
      />
    );
  }

  public done = (): void => {
    this.props.dispatch({
      type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
    });

    this.redirectBack();
  }

  public selectUnit = (unit: UnitInterface, isManuallySelected: boolean): void => {

    const unitContracts = unit.contracts.sort((contract1, contract2) => {
      if (contract1.firstDate < contract2.firstDate) {
        return 1;
      }

      if (contract1.firstDate > contract2.firstDate) {
        return -1;
      }

      return 0;
    });
    const firstDate = !!unitContracts[0] && !!unitContracts[0].endDate ? Time.nextDayFromDate(unitContracts[0].endDate) : Time.firstDateNextMonth();


    // when user want to create contract we should copy charge templates from unit
    let chargeTemplates = [];
    unit.defaultChargeTemplates.forEach(template => {
      let chargeTemplate = {
        amount: parseFloat(Formatter.simpleFormatNumber(template.amount).replace(",", ".")),
        currency: template.currency.getCurrencyId(),
        type: template.type.id,
        repeatPeriod: template.repeatPeriod.id,
        description: template.description,
        paymentOffset: template.paymentOffset?.getValue(),
        dueDateFirstPayment: firstDate,
        firstDate: firstDate,
        endDate: Time.formatOrNull(template.endDate),
        isDefault: false,
        isPaidDirectlyToOwner: template.isPaidDirectlyToOwner,
        isCollective: template?.isCollective,
      }
      chargeTemplates.push(chargeTemplate);
    });

    this.setState({
      hasModifiedData: isManuallySelected,
      chargeTemplates: chargeTemplates,
      selectedUnit: unit
    });
  }

  public clearUnit = (): void => {
    this.setState({
      selectedUnit: null,
      hasModifiedData: true
    });
  }

  public focusUnit = (): void => {
    (this.refs.PersonLookup as any) && (this.refs.PersonLookup as any).refs.instance.hide();
  }

  public saveDetailsBeforeRedirect = () => {
    this.state.hasModifiedData = false;

    const savedDataBeforeRedirecting = { ...this.props.app.savedDataBeforeRedirecting };

    this.props.dispatch({
      type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
    });

    const dataToBeSaved = { ...this.state };
    dataToBeSaved.hasModifiedData = true;
    savedDataBeforeRedirecting.dataToBeSaved = dataToBeSaved;

    this.props.dispatch({
      type: Constants.SAVED_DATA_BEFORE_REDIRECTING,
      payload: {
        savedDataBeforeRedirecting: { ...savedDataBeforeRedirecting }
      }
    });

    let contactRoleId = Tenant.contactRoleId;
    const indexForAdditionalPerson = this.state.lastSelectedIndex;

    if (Number.isInteger(indexForAdditionalPerson)) {
      if (this.state.additionalFields[indexForAdditionalPerson].contactForContractTypeId === 2) {
        contactRoleId = OccupantRole.contactRoleId;
      }

      if (this.state.additionalFields[indexForAdditionalPerson].contactForContractTypeId === 255) {
        contactRoleId = None.contactRoleId;
      }
    }

    this.props.dispatch({
      type: Constants.SAVED_DATA_BEFORE_REDIRECTING,
      payload: {
        savedDataBeforeRedirecting: {
          dataToBeSaved: dataToBeSaved,
          contractRoleId: contactRoleId,
          indexForAdditionalPerson: indexForAdditionalPerson
        }
      }
    });
  }

  public openTooltip = () => {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    });
  }

  public openAgencyFeeDialog = () => {
    return this.setState({
      isAgencyFeeDialogOpen: true
    });
  }

  public closeAgencyFeeDialog = () => {
    // sending empty error array to clear page errors
    this.props.dispatch({
      type: Constants.GLOBAL_AGENCY_FEE_CREATE_FAILURE,
      payload: {
        err: []
      }
    });

    this.closeMenuAgencyFees();
    this.setState({
      isAgencyFeeDialogOpen: false,
      isUpdating: false
    });
  }

  public addAgencyFee = (agencyFee): any => {
    if (agencyFee.chargeTypeIds.length === 0) {
      return this.props.dispatch({
        type: Constants.GLOBAL_AGENCY_FEE_CREATE_FAILURE,
        payload: {
          err: {
            fields: ["chargeTypeIds"],
            translatedMessage: this.trans("be_ajv_not_validated")
          }
        }
      });
    } else {
      this.props.dispatch({
        type: Constants.GLOBAL_AGENCY_FEE_CREATE_FAILURE,
        payload: {
          err: []
        }
      });
    }

    if (!agencyFee.fixedFee && !agencyFee.percentageFee || (agencyFee.fixedFee === 0 && agencyFee.percentageFee === 0)) {
      this.props.dispatch({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: this.trans("should_be_filled_one_of_the_fees_types"),
          type: "error"
        }
      });
      return;
    }

    const fixedFee = parseFloat((100 * parseFloat(String(Formatter.deleteExtraSpace(agencyFee.fixedFee)).replace(",", "."))).toFixed(2));
    const percentageFee = parseFloat(Formatter.deleteExtraSpace(agencyFee.percentageFee).replace(",", "."));
    agencyFee.fixedFee = isNaN(fixedFee) ? null : fixedFee;
    agencyFee.percentageFee = isNaN(agencyFee.percentageFee) ? null : percentageFee;
    const createdAgencyFee: AgencyFeeInterface = AgencyFeeFactory.create(agencyFee);

    this.setState({
      defaultAgencyFees: [createdAgencyFee]
    }, this.closeAgencyFeeDialog);
  }

  public updateAgencyFee = (agencyFee: AgencyFeeInterface): any => {
    this.setState({
      selectedAgencyFee: agencyFee,
      isUpdating: true,
      anchorElAgencyFees: null
    }, () => {
      this.openAgencyFeeDialog();
    });
  }

  public saveAgencyFee = (agencyFee: AgencyFeeInterface): any => {
    if (agencyFee.chargeTypeIds.length === 0) {
      return this.props.dispatch({
        type: Constants.GLOBAL_AGENCY_FEE_CREATE_FAILURE,
        payload: {
          err: {
            fields: ["chargeTypeIds"],
            translatedMessage: this.trans("be_ajv_not_validated")
          }
        }
      });
    } else {
      this.props.dispatch({
        type: Constants.GLOBAL_AGENCY_FEE_CREATE_FAILURE,
        payload: {
          err: []
        }
      });
    }

    if (!agencyFee.fixedFee && !agencyFee.percentageFee || (agencyFee.fixedFee === 0 && agencyFee.percentageFee === 0)) {
      this.props.dispatch({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: this.trans("should_be_filled_one_of_the_fees_types"),
          type: "error"
        }
      });
      return;
    }

    const fixedFee = parseFloat((100 * parseFloat(String(Formatter.deleteExtraSpace(String(agencyFee.fixedFee))).replace(",", "."))).toFixed(2));
    const percentageFee = parseFloat(Formatter.deleteExtraSpace(String(agencyFee.percentageFee)).replace(",", "."));
    agencyFee.fixedFee = isNaN(fixedFee) ? null : fixedFee;
    agencyFee.percentageFee = isNaN(agencyFee.percentageFee) ? null : percentageFee;
    const createdAgencyFee: AgencyFeeInterface = AgencyFeeFactory.create(agencyFee);

    this.setState({
      defaultAgencyFees: [createdAgencyFee]
    }, this.closeAgencyFeeDialog);
  }

  public deleteAgencyFee = () => {
    this.setState({
      defaultAgencyFees: [],
      isAgencyRemoveDialog: false,
      agencyFee: null
    });
  }

  public closePrompt = (): void => {
    this.setState({
      isAgencyRemoveDialog: false,
    })
  }

  protected openMenuAgencyFees = (event: any, agencyFee: AgencyFeeInterface): void => {
    this.setState({
      selectedAgencyFee: agencyFee,
      anchorElAgencyFees: event.currentTarget
    });
  }

  protected closeMenuAgencyFees = (): void => {
    this.setState({
      anchorElAgencyFees: null
    });
  }

  public getDefaultAgencyFees = () => {
    return this.state.defaultAgencyFees && this.state.defaultAgencyFees.map((agencyFee: AgencyFeeInterface) => {
      return (
        <TableRow
          hover
          key={agencyFee.id}
          className={`clickable-entity`}
          onClick={() => {
            this.updateAgencyFee(agencyFee);
          }}
        >
          <TableCell>
          </TableCell>
          <TableCell style={{ width: "30%" }}>
            {this.formatter.formatNumber(agencyFee.fixedFee, agencyFee.currency)}
          </TableCell>
          <TableCell style={{ width: "30%" }}>{`${this.formatter.simpleFormatNumber(agencyFee.percentageFee, false)}%`}</TableCell>
          <TableCell style={{ width: "35%" }}>{Formatter.checkTranslationType(this.trans(agencyFee.fixedPlusPercentageMode.label), agencyFee.fixedPlusPercentageMode.label)}</TableCell>
          <TableCell
            style={{ width: "5%" }}
            onClick={e => {
              e.stopPropagation();
            }}
          >
            <div>
              <IconButton
                onClick={e => this.openMenuAgencyFees(e, agencyFee)}
              >
                <div className="icon icon-ic-more-vert"></div>
              </IconButton>
              <Menu
                id="simple-menu"
                anchorEl={this.state.anchorElAgencyFees}
                open={Boolean(this.state.anchorElAgencyFees) && this.state.selectedAgencyFee?.id === agencyFee.id}
                onClose={this.closeMenuAgencyFees}
                disableAutoFocusItem={true}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center"
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left"
                }}
                getContentAnchorEl={null}
              >
                <MenuItem
                  onClick={() => this.updateAgencyFee(this.state.selectedAgencyFee)}
                >
                  <ListItemIcon><div className="icon icon-ic-edit icon-color"></div></ListItemIcon>
                  <ListItemText>{this.trans("menuitem-open")}</ListItemText>
                </MenuItem>
                <MenuItem
                  className="delete-action"
                  onClick={() => this.setState({ agencyFee: this.state.selectedAgencyFee, isAgencyRemoveDialog: true, anchorElAgencyFees: null })}
                >
                  <ListItemIcon><div className="icon icon-ic-remove icon-color remove-icon"></div></ListItemIcon>
                  <ListItemText>{this.trans("menuitem-delete")}</ListItemText>
                </MenuItem>
              </Menu>
            </div>
          </TableCell>
        </TableRow>
      );
    });
  }

  public getAgencyFeeDialogTitle = (): string => {
    return this.trans("dialog/agencyfee-title");
  }

  public renderNotificationDateQuicksets = () => {
    return (
      <div className="date-quickset-wrapper">
        <div
          className="date-quickset"
          onClick={() => this.selectDate(Time.useSetForExpirationDate(this.state.firstDate, 6), "lastDate")}
        >
          6
        </div>
        <div
          className="date-quickset"
          onClick={() => this.selectDate(Time.useSetForExpirationDate(this.state.firstDate, 12), "lastDate")}
        >
          12
        </div>
        <div
          className="date-quickset"
          onClick={() => this.selectDate(Time.useSetForExpirationDate(this.state.firstDate, 24), "lastDate")}
        >
          24
        </div>
      </div>
    );
  }

  public renderExpirationDateQuicksets = () => {
    return (
      <div className="date-quickset-wrapper">
        <div
          className="date-quickset"
          onClick={() => this.selectDate(Time.substractMonth(this.state.lastDate, 1), "expirationDate")}
        >
          1
        </div>
        <div
          className="date-quickset"
          onClick={() => this.selectDate(Time.substractMonth(this.state.lastDate, 2), "expirationDate")}
        >
          2
        </div>
        <div
          className="date-quickset"
          onClick={() => this.selectDate(Time.substractMonth(this.state.lastDate, 4), "expirationDate")}
        >
          4
        </div>
      </div>
    );
  }

  public selectTenant = (entity: CompanyInterface | PersonInterface, fromCoach: boolean): void => {
    this.setState({
      selectedTenant: entity,
      ignoredPeople: entity instanceof Person ? [entity, ...this.state.ignoredPeople] : [...this.state.ignoredPeople],
      hasModifiedData: true,
      openCoachCreateNewTenant: (entity instanceof Company && !entity?.generalContactId && !fromCoach) ? true : false,
      chargeTemplates: this.state.chargeTemplates.map((chargeTemplate: ChargeTemplateInterface) => {
        let contactId = chargeTemplate?.contactId;
        let companyId = chargeTemplate?.companyId;

        if (entity instanceof Person) {
          if (entity?.id) {
            contactId = entity?.id;
            companyId = undefined;
          }
        }

        if (entity instanceof Company) {
          if (entity?.id) {
            companyId = entity?.id;
            contactId = undefined;
          }
        }

        return {
          ...chargeTemplate,
          contactId: contactId,
          companyId: companyId
        }
      })
    });
  }

  public clearTenant = (): void => {
    this.setState({
      selectedTenant: null,
      hasModifiedData: true,
      chargeTemplates: this.state.chargeTemplates.map((chargeTemplate: ChargeTemplateInterface) => {
        let contactId = chargeTemplate?.contactId;
        let companyId = chargeTemplate?.companyId;

        if (this.state.selectedTenant instanceof Person) {
          if ((this.state.selectedTenant?.id && chargeTemplate?.contactId && this.state.selectedTenant?.id === chargeTemplate?.contactId)) {
            contactId = null;
            companyId = undefined;
          }
        }

        if (this.state.selectedTenant instanceof Company) {
          if ((this.state.selectedTenant?.id && chargeTemplate?.companyId && this.state.selectedTenant?.id === chargeTemplate?.companyId)) {
            companyId = null;
            contactId = undefined;
          }
        }

        return {
          ...chargeTemplate,
          contactId: contactId,
          companyId: companyId
        }
      })
    });
  }

  public changeAutoSendInvoiceToTenant = () => {
    this.setState({
      autoSendInvoiceToTenant: !this.state.autoSendInvoiceToTenant,
      hasModifiedData: true
    });
  }

  public changeAddressForRentEmail = () => {
    this.setState({
      addressForRentEmail: !this.state.addressForRentEmail,
      hasModifiedData: true
    });
  }

  public changeIsCommercial = () => {
    this.setState({
      isCommercial: !this.state.isCommercial,
      hasModifiedData: true
    });
  }

  public render() {
    const monthlyChargeTemplatesAmount = [...this.state.chargeTemplates]
      .filter((chargeTemplate: ChargeTemplateInterface) =>
        !chargeTemplate?.contractId &&
        chargeTemplate?.repeatPeriod === PeriodContainer.pickIdFromLabel("monthly") &&
        chargeTemplate?.amount
      )
      .map((chargeTemplate: ChargeTemplateInterface) => chargeTemplate?.amount)
      .reduce((a, b) => a + b, 0);

    return (
      <div className="state-app">
        <div className="box box-full has-details-page-header">
          <div className="component-header has-back-button two-row-title">
            <div className="inner-wrapper">
              <div className="back-arrow-wrapper" onClick={this.done}>
                <div className="icon icon-ic-arrow-back icon-color"></div>
              </div>
              <div className="title-wrapper">
                <h1>{this.trans("create-contract")}</h1>
              </div>
              <div className="button-container">
                <Button
                  color="primary"
                  onClick={this.done}
                  style={{ marginRight: "20px" }}
                >
                  {this.trans("button-cancel")}
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.save}
                  disabled={this.state.isSaving}
                >
                  {this.trans("button-create")}
                </Button>
              </div>
            </div>
            <div className="inner-wrapper" style={{ flexDirection: "column", alignItems: "flex-start" }}>
              <h4>{this.state.selectedUnit?.displayName}</h4>
            </div>
          </div>

          <div className="box component-contract-create">
            <div className="component-wrapper no-margin-top">
              <div className="component">
                <Card className="card">
                  <div style={{ padding: "10px 40px 10px 10px" }}>
                    <form>
                      {this.disablePersonId !== 0 && (
                        <div className="read-only-wrapper" style={{ margin: "0" }}>
                          <div className="name-field">
                            <div className="margin-wrapper">
                              {this.disablePersonId && <div >{`${this.trans("label-tenant")}: `}</div>}
                            </div>
                          </div>
                          <div className="margin-wrapper">
                            <div className="link-to-entity" onClick={() => {
                              if (this.state.selectedTenant instanceof Company) {
                                this.redirect(`/app/company/update/${this.state.selectedTenant?.id}`);
                              } else if (this.state.selectedTenant instanceof Person) {
                                this.redirect(`/app/person/update/${this.state.selectedTenant?.id}`);
                              }
                            }}>
                              {this.state.selectedTenant?.displayName}
                            </div>
                          </div>
                        </div>
                      )}

                      {/* use this when create contract from tenant details page */}
                      {
                        this.disableUnitId === 0 && (
                          <div style={{ margin: "-14px 0 -4px 0" }}>
                            <UnitLookup
                              {...this.props}
                              id="unitId"
                              name="unitId"
                              ref="UnitLookup"
                              className="scroll-to-unitId"
                              additionalClasses="unit-lookup-component"
                              floatingLabelText={this.trans("dropdown-searchforunit-label")}
                              autoSelectId={this.state.selectedUnit?.id}
                              disabled={this.disableUnitId !== 0}
                              onSelect={this.selectUnit}
                              onClear={this.clearUnit}
                              fullUnitName={true}
                              autoFocus={true}
                              forceUpdatePage={true}
                              saveDetailsBeforeRedirect={this.saveDetailsBeforeRedirect}
                              error={this.getErrorFor("unitId")}
                              width="100%"
                              containerWidth="60%"
                            />
                          </div>
                        )
                      }

                      {/* use this when create contract from unit details page */}
                      {
                        this.disablePersonId === 0 && (
                          <div style={{ margin: "-14px 0" }}>
                            <div style={{ display: "flex", alignItems: "center" }}>
                              <div className="search-bar-container" style={{ width: "60%" }}>
                                <Searchbar
                                  {...this.props}
                                  name="personId"
                                  className="scroll-to-mainTenantContactId"
                                  id="selectedTenantForContract"
                                  ref="TenantLookup"
                                  floatingLabelText={this.trans("label-tenant")}
                                  allResults={true}
                                  objectField={true}
                                  onChange={this.selectTenant}
                                  onClear={this.clearTenant}
                                  selectedEntity={this.state.selectedTenant}
                                  searchParameter={"contactsSearch"}
                                  error={this.getErrorFor("mainTenantContactId") || this.getErrorFor("contactForContracts[0].contactId")}
                                  disabled={this.disablePersonId !== 0}
                                  searchText={this.state.selectedTenant ? `${this.state.selectedTenant.nameOfEntity}, ${this.state.selectedTenant.displayName}` : null}
                                  styleInModal={"pick-object-modal"}
                                  createButton={"dropdown-button/newtenant"}
                                  openCoachCreateNewEntity={() => {
                                    this.setState({
                                      openCoachCreateNewTenant: true,
                                      selectedTenant: null
                                    })
                                  }
                                  }
                                />
                              </div>

                              <TextField
                                className="form-element"
                                style={{ width: "30%", boxSizing: "border-box", marginLeft: "45px" }}
                                type="text"
                                label={this.trans("label-description")}
                                value={this.trans("label-tenant")}
                                variant="standard"
                                disabled={true}
                                error={false}
                              />
                            </div>
                          </div>
                        )
                      }

                      {this.renderAdditionalFields()}

                      {this.state.selectedTenant && (
                        <div style={{ margin: "10px 0 0 0" }}>
                          <Button
                            color="primary"
                            style={{
                              width: "60%",
                              boxSizing: "border-box",
                              border: "1px solid rgba(0,0,0,.1)",
                              display: "inline-block",
                              marginLeft: "0px"
                            }}
                            className="plus-button"
                            onClick={this.addAdditionalFields}
                          >
                            {this.trans("contract-create-button-add-person-to-contract")}
                          </Button>
                        </div>
                      )}

                      <DatePickerComponent
                        {...this.props}
                        id="firstDate"
                        name="firstDate"
                        className="scroll-to-firstDate"
                        label={this.trans("first-date") + Time.getDatepickerHint()}
                        initialDate={this.state.firstDate}
                        onChange={date => this.selectDate(date, "firstDate")}
                        clearButton={true}
                        width="60%"
                        error={this.getErrorFor("firstDate")}
                        margin={"10px 0px 0px 0px"}
                      />

                      <div style={{ display: "flex", alignItems: "center" }}>
                        <div className="wrapper-for-field" style={{ width: "60%" }}>
                          <DatePickerComponent
                            {...this.props}
                            id="lastDate"
                            name="lastDate"
                            className="scroll-to-lastDate"
                            label={this.trans("expiration-date") + " 1" + Time.getDatepickerHint() + this.trans("field/optional")}
                            initialDate={this.state.lastDate}
                            onChange={date => this.selectDate(date, "lastDate")}
                            minDate={this.state.firstDate}
                            minDatePlusDays={1}
                            minDateMessage={this.trans("field/lastfinalenddate-info/error")}
                            hint={this.state.datepickerHint}
                            clearButton={true}
                            error={this.state.datepickerError}
                            margin={"7px 0px 0px 0px"}
                          />
                          <div className={`block-tooltip ${this.state.tooltipOpen ? 'open-tooltip' : 'close-tooltip'}`} onClick={this.openTooltip}>
                            <div id="tooltip-block" className="tooltip-icon">?</div>
                            <span id="hidden-hint" className="hidden">{this.trans("page/contracts-hint/lastdate-info")}</span>
                          </div>
                        </div>
                        {this.renderNotificationDateQuicksets()}
                      </div>

                      <DatePickerComponent
                        {...this.props}
                        id="finalDate"
                        name="finalDate"
                        className="scroll-to-finalRentalPeriodDate"
                        label={this.trans("expiration-date") + " 2" + Time.getDatepickerHint() + this.trans("field/optional")}
                        initialDate={this.state.finalRentalPeriodDate}
                        onChange={date => this.selectDate(date, "finalRentalPeriodDate")}
                        minDate={this.state.firstDate}
                        minDatePlusDays={1}
                        minDateMessage={this.trans("field/lastfinalenddate-info/error")}
                        clearButton={true}
                        width="60%"
                        error={this.getErrorFor("finalRentalPeriodDate")}
                        margin={"7px 0px 0px 0px"}
                      />

                      <div style={{ display: "flex", alignItems: "center" }}>
                        <DatePickerComponent
                          {...this.props}
                          id="expirationDate"
                          name="expirationDate"
                          className="scroll-to-expirationDate"
                          label={this.trans("contract-expiration-date") + Time.getDatepickerHint() + this.trans("field/optional")}
                          initialDate={this.state.expirationDate}
                          onChange={date => this.selectDate(date, "expirationDate")}
                          minDate={this.state.firstDate < new Date() ? new Date() : this.state.firstDate}
                          minDatePlusDays={0}
                          clearButton={true}
                          width="60%"
                          error={this.getErrorFor("expirationDate")}
                          margin={"7px 0px -5px 0px"}
                        />
                        {this.renderExpirationDateQuicksets()}
                      </div>

                      <div style={{ width: "60%" }}>
                        <TextField
                          autoComplete="off"
                          id="note"
                          name="note"
                          className="form-element full-size scroll-to-note"
                          type="text"
                          multiline={true}
                          rowsMax={10}
                          label={this.trans("note") + this.trans("field/optional")}
                          value={this.state.note}
                          onChange={this.sync.bind(this, this.syncronizers.EVENT, "note")}
                          variant="standard"
                          error={!!this.getErrorFor("note")}
                          helperText={this.getErrorFor("note")}
                        />
                      </div>

                      <div>
                        <div style={{ marginTop: "-10px" }}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={this.state.isCommercial}
                                onChange={this.changeIsCommercial}
                                color="primary"
                              />
                            }
                            label={this.trans("page/contracts-label/iscommercialcontract", { vatPercentage: this.props?.app?.settings?.agency?.vatPercentage })}
                          />
                        </div>

                        <div style={{ paddingBottom: "20px" }}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={this.state.autoSendInvoiceToTenant}
                                onChange={this.changeAutoSendInvoiceToTenant}
                                color="primary"
                              />
                            }
                            label={this.trans("page/contracts-label/automaticallysendrentinvoice")}
                          />
                        </div>
                      </div>
                    </form>
                  </div>
                </Card>
              </div>
            </div>

            <div className="component-wrapper no-shadow">
              <Card className="card no-padding">
                <div className="label-container no-border" style={{ backgroundColor: "#f9f9f9", height: "59px" }}>
                  <Button
                    color="primary"
                    variant="outlined"
                    onClick={this.openChargeTemplateCreatePopup}
                    style={{
                      margin: "0 40px 0 0",
                      padding: "0 10px",
                      height: "50px"
                    }}
                  >
                    {this.trans("dialog/newcontractitems-title")}
                  </Button>
                </div>
                <div>
                  <div
                    style={{
                      padding: "10px 12px 10px 10px",
                      marginBottom: "10px"
                    }}
                  >
                    {
                      !!monthlyChargeTemplatesAmount ?
                        Translator.transJSX("pages/contract-section/price-info/totalmonthlyamount", { amount: <span style={{ fontWeight: "bold" }}>{this.formatter.formatNumber(monthlyChargeTemplatesAmount * 100, this.state.chargeTemplates[0] && CurrencyContainer.pickFromId(this.state.chargeTemplates[0].currency))}</span> }) :
                        Translator.transJSX("pages/contract-section/price-info/totalmonthlyamount", { amount: <span style={{ fontWeight: "bold" }}>{this.formatter.formatNumber(monthlyChargeTemplatesAmount, this.props.app.settings.user.currency)}</span> })
                    }
                  </div>
                  <div>
                    {
                      this.state.chargeTemplates
                        .map((chargeTemplate: ChargeTemplateInterface, index: number) => {
                          return (
                            <div className="component-wrapper no-margins has-margin-bottom">
                              <div className="component">
                                <ChargeTemplateCard
                                  key={`chargeTemplate-${chargeTemplate?.id}`}
                                  chargeTemplate={chargeTemplate}
                                  openChargeTemplate={() => this.setState({ selectedChargeTemplate: chargeTemplate, selectedChargeIndex: index }, () => this.openChargeTemplateUpdatePopup(this.state.selectedChargeTemplate, this.state.selectedChargeIndex))}
                                  removeChargeTemplate={() => this.setState({ selectedChargeTemplate: chargeTemplate, selectedChargeIndex: index }, () => this.deleteChargeTemplate())}
                                />
                              </div>
                            </div>
                          );
                        })
                    }
                  </div>
                </div>
              </Card>
            </div>

            <div className="component-wrapper">
              <Attachment
                {...this.props}
                typeOfComponent="shared"
                title={this.trans("attachments-for-contract")}
                relation="contractId"
                onAmazonFolderNameGeneration={!this.state.amazonFolderName ?
                  this.sync.bind(this, this.syncronizers.VALUE, "amazonFolderName") : null}
                amazonFolderName={!!this.state.amazonFolderName ? this.state.amazonFolderName : null}
                attachments={this.state.attachments}
                updateParentState={attachments => this.setState({ attachments: attachments })}
                onChangeAvatar={avatar => (this.refs.EntityAvatar as any) && (this.refs.EntityAvatar as any).change(avatar)}
                onLastImageDeleted={() => (this.refs.EntityAvatar as any) && (this.refs.EntityAvatar as any).revert()}
              />
            </div>
          </div>
        </div>

        <LeavePromptDialog
          {...this.props}
          prioritizeClosing={true}
          onClose={() => this.setState({ openLeavePrompt: false, nextPath: "" })}
          openLeavePrompt={this.state.openLeavePrompt}
          onDiscard={this.leave.bind(this)}
          onSave={() => { this.setState({ openLeavePrompt: false }); this.save(); }}
          hideCross={true}
          leavePrompt={true}
        />

        <DeleteEntityPrompt
          {...this.props}
          entityName={'agency-fee-remove-from-settings-page'}
          isOpen={this.state.isAgencyRemoveDialog}
          onCancel={this.closePrompt}
          onDelete={this.deleteAgencyFee}
        />

        <CoachNewTenantDialog
          {...this.props}
          openCoachCreateNewTenant={this.state.openCoachCreateNewTenant}
          existingTenant={this.state.selectedTenant instanceof Company ? this.state.selectedTenant : null}
          onCloseTenantCoach={entity => {
            if (entity) {
              this.setState({
                openCoachCreateNewTenant: false
              }, () => this.selectTenant(entity, true))
            } else {
              this.setState({
                openCoachCreateNewTenant: false
              })
            }
          }}
        />

        <PromptDialog
          {...this.props}
          title={this.state.newChargeTemplatePopupOpen ? this.trans("dialog/newcontractitems-title") : this.trans("dialog/contractitemdetails-title")}
          content={this.getChargeTemplatePopupContent()}
          openLeavePrompt={this.state.isChargeTemplatePopupOpen}
          onClose={this.closeChargeTemplatePopup}
          onlyPositiveButton={false}
          prioritizeClosing={true}
          withoutDefaultDilaogButtons={true}
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    units: state.units,
    component: state.contractCreate,
    chargeTemplateCreate: state.chargeTemplateCreate,
    chargeTemplateUpdate: state.chargeTemplateUpdate,
    globalTypes: state.globalTypes,
    agencyFeeCreate: state.agencyFeeCreate,
    agencyFeeUpdate: state.agencyFeeUpdate
  };
};

export default connect(mapStateToProps)(
  ContractCreate
);
